import Vue from "vue";
import axios from "axios";
import router from '@/router/router'
import VueAxios from "vue-axios";
import { Message } from 'element-ui'
 
Vue.use(VueAxios, axios) 

axios.defaults.timeout = 30000
// 返回其他状态吗
axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500 // 默认的
}
// 跨域请求，允许保存cookie
axios.defaults.withCredentials = false

// HTTP request拦截
axios.interceptors.request.use(config => {
  config.url = 'http://43.135.47.161:7081' + config.url
  // config.url = 'http://192.168.1.133:7081' + config.url
  // config.url = 'https://subsite.intelligentcarbon.ai' + config.url
  config.headers['Accept-Language'] = localStorage.getItem('language') || 'zh-CN'
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token// token
  }
  return config
}, error => {
  return Promise.reject(error)
})

// HTTP response拦截
axios.interceptors.response.use(res => {
  const status = Number(res.status) || 200
  const message = res.data.message || res.data.errors || res.statusText
  if (status === 401) {
    Message({
      message: message,
      type: 'error'
    })
    return
  }
  // console.log(res)
  if(res.config.url.indexOf('/app-api/global/global-data-info-amount/add') > -1 || res.config.url.indexOf('/app-api/global/global-data-info-amount/edit') > -1 || res.config.url.indexOf('/app-api/global/global-data-info/export') > -1 || res.config.url.indexOf('/app-api/global/global-data-info/qy/export') > -1 || res.config.url.indexOf('/app-api/global/global-data-info/hy/export') > -1 || res.config.url.indexOf('/app-api/global/global-recharge-order/add') > -1 || res.config.url.indexOf('/app-api/global/global-recharge-order/edit') > -1){
    return res.data
  }else{
    console.log(res.data.code)
    if(res.data.code == 'U0231'){
      Message({
        message: message,
        type: 'error'
      })
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      router.push('/login/index?type=1')
    }
    if (status !== 200 || res.data.code !== '20001') {
      Message({
        message: message,
        type: 'error'
      })
      return Promise.reject(new Error(message))
    }
    if (res && res.data && res.data.data && res.data.data.records) {
      res.data.data.total = Number(res.data.data.total)
      res.data.data.size = Number(res.data.data.size)
      res.data.data.pages = Number(res.data.data.pages)
      res.data.data.current = Number(res.data.data.current)
    }
    return res.data.data
  }
}, error => {
  return Promise.reject(new Error(error))
})

export default axios


// WEBPACK FOOTER //
// ./src/utils/axios.js